module.exports = __webpack_public_path__ + "img/试剂柜.60f398ef.jpg";